export const getDownloadUrl = async ({ dispatch }, id) => {
	const { data = {} } = await dispatch('request', { method: 'GET', path: `export/download/${id}` });

	return data.url;
};
